import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listTags, createTag, updateTag, deleteTag } from './api';
import type { CreateTagPayload, UpdateTagPayload } from './types';

const TAGS_QUERY_KEY = ['tags'];

/**
 * タグ一覧を取得するフック
 */
export function useTags() {
  return useQuery({
    queryKey: TAGS_QUERY_KEY,
    queryFn: listTags,
  });
}

/**
 * タグを作成するフック
 */
export function useCreateTag() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateTagPayload) => createTag(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY });
    },
  });
}

/**
 * タグを更新するフック
 */
export function useUpdateTag() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ tagId, payload }: { tagId: string; payload: UpdateTagPayload }) =>
      updateTag(tagId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY });
    },
  });
}

/**
 * タグを削除するフック
 */
export function useDeleteTag() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (tagId: string) => deleteTag(tagId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY });
    },
  });
}
